// DialogHistory.js
import styles from './DialogScreen.module.css';
import { playUserAudio, toggleTranslation } from '../../utils/dialogUtils';
import { useAppConfig } from '../../context/AppConfigContext';

export const DialogHistory = ({ dialogHistory, showTranslation, dispatch, combinedIsAndroidApp, site }) => {
  const { t } = useAppConfig();

  return (
    <div className={styles.dialogContent}>
      {dialogHistory.map((entry, index) => {
        const audioSrc = `${combinedIsAndroidApp ? site : ''}${entry.audioUrl}`;
        return (
          <div
            key={index}
            className={styles.assistantText} // одинаковый класс для обоих ролей, можно упростить
            onClick={() => toggleTranslation(dispatch, `history-${index}`)}
          >
            <div className={styles.optionContent}>
              {entry.audioUrl && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    playUserAudio(audioSrc, dispatch);
                  }}
                  className={styles.audioButton}
                >
                  <svg viewBox="0 0 24 24" className={styles.audioIconUser}>
                    <path d="M3 10v4h4l5 5V5L7 10H3zm13.5 2c0-1.77-1.02-3.29-2.5-4.03v8.06A4.984 4.984 0 0 0 16.5 12zm2.5 0c0 3.04-1.64 5.64-4.06 7.03l1.43 1.43A9.969 9.969 0 0 0 22 12c0-3.73-2.05-6.99-5.13-8.64l-1.43 1.43A7.97 7.97 0 0 1 19 12z" />
                  </svg>
                </button>
              )}
              <div className={styles.textContent}>
                <p>{entry.text}</p>
                {showTranslation[`history-${index}`] && (
                  <p className={styles.translation}>{entry.textTranslate}</p>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
